import chapters from '../data/legacy-chapters.json';
import blocks from '../data/legacy-blocks.json';
import type {Bookmark,Position} from '../types';
const chapterMap=chapters as Record<string,Record<string,string>>;
const blockMap=blocks as Record<string,string>;
export function migrateReading<T extends Bookmark|Position>(entry:T):T{
 const key=entry.book+'/'+entry.edition,chapter=blockMap[key+'/'+entry.block]||chapterMap[key]?.[entry.chapter]||entry.chapter;
 if('kind' in entry&&(entry.kind==='note'||entry.kind==='verse'))return entry;
 return {...entry,chapter,...('id' in entry?{id:`${key}/${chapter}/${entry.block}`}:{})};
}
